import { create } from 'zustand';
import { useMaterialsPanelStore } from './materialsPanelStore';

/**
 * usodeki 用の軽量ページオーバーレイ。
 * 1 画面構成の usodeki では「利用状況 / マイページ」を別ルートへフルリロード遷移せず、
 * ホーム上のオーバーレイで開いて ✕ で戻せるようにする (戻る導線の確保)。
 */
export type OverlayPage = 'dashboard' | 'profile';

interface PageOverlayState {
  active: OverlayPage | null;
  open: (page: OverlayPage) => void;
  close: () => void;
}

export const usePageOverlayStore = create<PageOverlayState>((set) => ({
  active: null,
  open: (page) => {
    // 素材パネル (right-panel: --z-modal) はオーバーレイ (--z-modal-backdrop) より
    // 前面にあり、開いたままだとオーバーレイの手前に残ってしまう。オーバーレイは
    // 全画面の暗幕付きで背後のパネルは見えないため、開く際にパネルを閉じておく。
    useMaterialsPanelStore.getState().close();
    set({ active: page });
  },
  close: () => set({ active: null }),
}));
